import axios from '@/plugins/axios';

export default {
  checkSameTeam(tenantId, userId1, userId2) {
    return axios.get(`/v2/team/checksameteam/${tenantId}/${userId1}/${userId2}`)
      .then(response => response.data);
  },
};
